import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-success-generico',
    templateUrl: './success-generico.component.html',
    styleUrls: ['./success-generico.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuccessGenericoComponent {

  @Input() successGenerico = false;
  @Output() alertFechou = new EventEmitter();

  constructor() { }

  fechar() { this.alertFechou.emit('Fechou'); }

}
